import { isObject } from './typeChecks';

export const getCookie = (key: string) => {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const [cookieName, cookieValue] = cookie.split('=');

    if (cookieName.trim() === key) {
      return decodeURIComponent(cookieValue);
    }
  }
  return null;
};

export const setCookie = (key: string, value: string) => {
  document.cookie = key + '=' + encodeURIComponent(value) + '; path=/';
};

export const removeCookie = (key: string) => {
  if (getCookie(key) !== null) {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
};

export const setCookieWithExpiry = (
  key: string,
  value: string | object,
  expiryMin = 60,
) => {
  const valueStr = isObject(value) ? JSON.stringify(value) : value;
  const encodedValue = encodeURIComponent(valueStr);
  const expiryDate = new Date();
  expiryDate.setTime(expiryDate.getTime() + expiryMin * 60 * 1000);
  document.cookie =
    key +
    '=' +
    encodedValue +
    ';expires=' +
    expiryDate.toUTCString() +
    ';path=/';
};
